import { createContext } from "react";
/**
 * The id does not not change since it is a primitive value
 */
export const ConfigurationObjectIdContext = createContext("");
ConfigurationObjectIdContext.displayName = "ConfigurationObjectIdContext";
//# sourceMappingURL=ConfigurationObjectIdContext.js.map